export const mapOperationalStateToDisplay = (operationalState) => {
  if (operationalState === 'Upgrade') return 'Under Upgrade';
  if (!operationalState) return 'Available';
  return operationalState;
};

export const normalizeAdminBooking = (booking) => {
  if (!booking) return null;

  return {
    bookedUserName: booking.bookedBy || booking.bookedUserName || '',
    bookedUserEmail: booking.bookedUserEmail || '',
    customerName: booking.userCompany || booking.customer || booking.customerName || '',
    bookingType: booking.bookingType || '',
    bookingStartTime: booking.bookingStartTime || '',
    bookingEndTime: booking.bookingEndTime || '',
    sfdcNumber: booking.sfdc || booking.sfdcNumber || '',
    faultStatus: booking.faultStatus || '',
  };
};

export const getAdminTenantId = (tenant) => `${tenant?.tenantType}-${tenant?.tenantNumber}`;

export const normalizeAdminTenantListItem = (tenant) => ({
  id: getAdminTenantId(tenant),
  tenantNumber: tenant?.tenantNumber,
  tenantType: tenant?.tenantType,
  tenantUrl: tenant?.tenantUrl || '',
  itsmUrl: tenant?.itsmUrl || '',
  labels: Array.isArray(tenant?.labels) ? tenant.labels : [],
  tenantFeatures: Array.isArray(tenant?.tenantFeatures) ? tenant.tenantFeatures : [],
  versionFeatures: Array.isArray(tenant?.versionFeatures) ? tenant.versionFeatures : [],
  status: tenant?.status ?? null,
  rawStatus: tenant?.status ?? null,
  rawOperationalState: tenant?.operationalState ?? null,
  operationalState: tenant?.operationalState ?? null,
  displayStatus: mapOperationalStateToDisplay(tenant?.operationalState),
  currentBooking: normalizeAdminBooking(tenant?.currentBooking),
  isActive: true,
});

const hasConfiguredValue = (value) => value != null && value !== '';

export const normalizeAdminTenantDetail = (tenant) => {
  const base = normalizeAdminTenantListItem(tenant);

  return {
    ...base,
    username: tenant?.username || '',
    hasDetail: true,
    integrationConfigured: {
      jira: hasConfiguredValue(tenant?.jiraUrl)
        || hasConfiguredValue(tenant?.jiraUsername)
        || hasConfiguredValue(tenant?.jiraPassword),
      catchpoint: hasConfiguredValue(tenant?.catchpointUrl)
        || hasConfiguredValue(tenant?.catchpointUsername)
        || hasConfiguredValue(tenant?.catchpointPassword),
      chatops: hasConfiguredValue(tenant?.chatopsUsername)
        || hasConfiguredValue(tenant?.chatopsPassword),
      dynatrace: hasConfiguredValue(tenant?.dynatraceHost)
        || hasConfiguredValue(tenant?.dynatraceUsername)
        || hasConfiguredValue(tenant?.dynatracePassword),
    },
    credentials: {
      password: tenant?.password || '',
      apiKey: tenant?.apiKey || '',
      accessKey: tenant?.key || '',
      secretKey: tenant?.secretKey || '',
      jira: {
        url: tenant?.jiraUrl || '',
        username: tenant?.jiraUsername || '',
        password: tenant?.jiraPassword || '',
      },
      catchpoint: {
        url: tenant?.catchpointUrl || '',
        username: tenant?.catchpointUsername || '',
        password: tenant?.catchpointPassword || '',
      },
      chatops: {
        username: tenant?.chatopsUsername || '',
        password: tenant?.chatopsPassword || '',
      },
      dynatrace: {
        host: tenant?.dynatraceHost || '',
        username: tenant?.dynatraceUsername || '',
        password: tenant?.dynatracePassword || '',
      },
    },
  };
};
